import React from 'react';
import { Box, Typography, Button, alpha, Chip, Skeleton } from '@mui/material';
import { styled } from '@mui/material/styles';
import AddIcon from '@mui/icons-material/Add';
import { RiSurveyLine } from 'react-icons/ri';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

// Color palette
const COLORS = {
  primary: '#2196f3',
  success: '#4caf50',
  warning: '#ffc107',
  error: '#f44336',
  purple: '#673ab7',
  background: '#f7f9fc',
  lightBorder: '#e3f2fd',
};

const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  textTransform: 'none',
  fontWeight: 600,
  boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.1)',
  '&:hover': {
    boxShadow: '0px 4px 8px -1px rgba(0,0,0,0.15)',
  },
}));

const PageHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(4),
  paddingBottom: theme.spacing(2),
  borderBottom: `1px solid ${COLORS.lightBorder}`,
}));

const SurveyHeader = ({ onCreateSurvey, hasActiveSurvey, loading = false }) => {
  const renderStatusIndicator = () => {
    if (loading) {
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Skeleton variant="circular" width={16} height={16} />
          <Skeleton variant="text" width={120} height={20} />
        </Box>
      );
    }

    if (hasActiveSurvey) {
      return (
        <Chip
          icon={<PlayArrowIcon />}
          label="Encuesta activa"
          size="small"
          sx={{
            backgroundColor: alpha(COLORS.success, 0.1),
            color: COLORS.success,
            border: `1px solid ${alpha(COLORS.success, 0.3)}`,
            fontWeight: 600,
          }}
        />
      );
    }

    return (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ fontStyle: 'italic', fontWeight: 500 }}>
        Ninguna encuesta está activa actualmente
      </Typography>
    );
  };

  return (
    <PageHeader>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
        <RiSurveyLine
          size={32}
          color={COLORS.primary}
          style={{ marginTop: 4 }}
        />
        <Box>
          <Typography variant="h4" fontWeight={700} color="#424242">
            Encuestas de Satisfacción
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Crea encuestas para medir la satisfacción de tus clientes con el
            chatbot
          </Typography>
          <Box sx={{ mt: 1, minHeight: 32, display: 'flex', alignItems: 'center' }}>
            {renderStatusIndicator()}
          </Box>
        </Box>
      </Box>
      <StyledButton
        variant="contained"
        startIcon={<AddIcon />}
        onClick={onCreateSurvey}
        disabled={loading}
        sx={{ backgroundColor: COLORS.primary }}>
        Nueva Encuesta
      </StyledButton>
    </PageHeader>
  );
};

export default SurveyHeader;
